export enum ProductQuantityType {
  'CART_CARD_VARIANT' = 'CART_CARD_VARIANT',
  'FREE_PRODUCT_CARD' = 'FREE_PRODUCT_CARD',
  'AllPRODUCTCARD' = 'AllPRODUCTCARD',
  'APOINT_PRODUCT_CARD' = 'APOINT_PRODUCT_CARD',
}
